import { Component, OnInit,ViewChild,ElementRef } from '@angular/core';
import { LibraryService, Dropobj,CirculationService, MasterService } from '../../services/index';
import { Calendar } from 'primeng/primeng';

import { HttpClient } from '@angular/common/http';
import {NgbModal, ModalDismissReasons,NgbModalOptions,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import { ChartType } from 'chart.js';
import { MultiDataSet } from 'ng2-charts';
import { ChartDataSets , RadialChartOptions } from 'chart.js';
import { SingleDataSet, Label, monkeyPatchChartJsLegend, monkeyPatchChartJsTooltip } from 'ng2-charts';
import {  ChartOptions } from 'chart.js';
import { Color} from 'ng2-charts';

@Component({
  selector: 'app-circulation',
  templateUrl: './circulation.component.html',
  styleUrls: ['./circulation.component.scss'],
  providers:[LibraryService,CirculationService,MasterService]
})
export class CirculationComponent implements OnInit {

  memberdetails:any[]=[];
  bookdetails:any[]=[];
  issuedetails:any[]=[];
  closeResult: string;
  modalOptions:NgbModalOptions;
  private modalRef: NgbModalRef;
  showload:any="";
  Modeot:any=[];
  retalmodalOptions:NgbModalOptions;
  private retalmodalRef: NgbModalRef;
  selitem:any={};
  selbook:any={};
  mop:any='1';
  retremarks:any='';
  selmember:any={};
  dashcounts:any={};
  booksmodel:any={};
  oprtype:string='';
  objissued:any={};
  selres:string='return';
  selfine:string='1';
  bkretstatus:string='';
  infotag:string='allcirculated1';
  arrselbooks=[];
  arrallrenbooks=[];
  arrmemtypes=[{value: 'Student', label: 'Student'},
  {value: 'Staff', label: 'Staff'},];
  memtype='Student';
   isLoadingResult: boolean;
   date1: any;
   dtissue:any;
   dtdue:any;
   isremarks:any;
   dueday:any='0';
   selstatus:any='returned';
   showisuemodal:boolean=false;
   fserdt:any;
     fserdt4:any;
     recdt:any;
     arrhis=[];
     selstat='returned';
     isrenewable:boolean=false;
     showfine:boolean=false;
     rdbselect:any='sel';
     rdbscan:boolean=false;
     objretdata:any={};
     dtrec:any;
     objcopies:any={};
     arractmember:any=[];
     memid:any='';
     bkaccno='';
     isdisabled=false;
  arrcirdept:any=[];
  arrcirdate:any=[];
  arrcirmonth:any=[];
  arrhisfine:any=[];
  catwiseissued:any=[];
  issuedinfocnt:any={};
  arrallretbooks:any=[];
  arrpopcirculation:any=[];
  sertxt:any='';
   @ViewChild('btnTest', {static: false}) btnTest:any;
   @ViewChild('calendar') calendar:Calendar;
  renarrselbooks: any=[];
  retremaparr: any=[];
  arrissuehis: any=[];
  studentinfo:any={};

  constructor(private http: HttpClient,private mservice:MasterService, private liservice: LibraryService,private modalService: NgbModal,private cservice:CirculationService) {
    //this.fserdt=this.liservice.getdatetoday();
   // this.fserdt4=this.liservice.getdatetoday();
   // this.recdt=this.liservice.getdatetoday();
this.getdatetoday();

   }

   ngOnInit(): void {
    this.isLoadingResult=false;
  //let today= new Date().toISOString().slice(0, 19).replace('T', ' ');
    //this.dtissue = new Date();
    //this.dtdue = today.getMonth() + '/' + today.getDate() + '/' + today.getFullYear();
    //this.dtdue = new Date();
    // this.dtdue.setDate(this.dtdue.getDate()+ 12);
    // console.log('date',this.dtdue);
    let today = new Date();
    //.fserdt=this.liservice.getdatetoday();
   // this.fserdt4=this.liservice.getdatetoday();
    this.Dasheadcounts();
    this.getallissuedbooks('allcirculated');
    this.Booksissue_received('dailybooks');
    
  }

  getdatetoday() {
    this.liservice.getsysdatetoday()
        .subscribe(
        resultArray => {
            console.log('getlibsource', resultArray);
            this.fserdt = resultArray;
            this.fserdt4 = resultArray;
            this.recdt = resultArray;
            
        },
        error => console.log("Error :: " + error)
        )
  }


  ngDoCheck()
  {
    //this.dtdue.setDate(this.dtdue.getDate()+ parseInt(nod));

  }
  keyword = 'name';
  keyword1 = 'title';
  acYears = [
    {value: 'return', label: 'Return'},
    {value: 'renew', label: 'Renew'},
  
  ];

  statuses = [
    {value: 'All', label: 'All'},
    {value: 'Issued', label: 'Issued'},
    {value: 'returned', label: 'Returned'},
    
  
  ];
  finereasons = [
    
    {value: 'Satisfactory', label: 'Satisfactory'},
    {value: 'Damaged', label: 'Damaged'},
    {value: 'Cost Recovered', label: 'Cost Recovered'},
    {value: 'Other', label: 'Other'},
  
  ];

  issuestatus = [
    
    {value: 'Issued', label: 'Issued'},
    {value: 'Void', label: 'Void'},
    
  
  ];

  bkreturnstatus = [
    
    {value: 'Issued', label: 'Issued'},
    {value: 'returned', label: 'returned'},
    
  
  ];
  barChartOptions: ChartOptions = {
    responsive: true,
  };
  barChartLabels: Label[] = [];
  barChartType: ChartType = 'bar';
  barChartLegend = true;
  barChartPlugins = [];
  barChartColors: Color[] = [
    {
      
      backgroundColor: '#FF00CC',
    },
    {
     
      backgroundColor: '#0033FF',
    },
  ];
  barChartData: ChartDataSets[] = [
    // { data: [45, 37, 60, 70, 46, 33], label: 'Best Fruits' }
  ];

  Dasheadcounts()
  {
      this.liservice.Getdashboarddata('dashcounts')
    .subscribe(
           resultArray =>{
   // this.liservice.Getdashboarddata('dashcounts')
      console.log('result-dashcounts',resultArray) ;
      this.dashcounts=resultArray[0];


      },
     error => console.log('Error :: ' + error)
  );
  }

  returnbulk()
  {
   
  if (confirm('Are you sure you want to return sected book(s)'))
  {
    this.isdisabled=true;
    this.showload='yes';
    var selbooks= this.arrallretbooks.filter(function(arr)
    {

      return arr.selected==true;
    })
    let clcd=localStorage.getItem('clcd');
    let aycd=localStorage.getItem('aycd');
    var selretbooks= selbooks.map( o => { return { id: o.id, bookid: o.bookid,stuid: o.stuid,memtype: o.memtype,renduedt:o.renduedt,duedt:o.duedt,nod:o.nod,fineamt:o.fineamt,remarks:this.retremarks,mop:this.mop} });
    
    console.log('selbook-SAVE',JSON.stringify(selretbooks));
    
    var asgnmtdata = { recdt: this.recdt,  clcd:clcd,aycd:aycd,issuedtls:selretbooks
    
  };
    console.log('asgnmtdata-SAVE', asgnmtdata);
    this.liservice.bulkreturnbook(asgnmtdata)
    .subscribe(result => {
        console.log('ret',JSON.stringify(result));
        alert (result.message);
        this.isdisabled=false;
        this.showload='no';
        this.retremarks="";
        this.mop='1';
        //this.getallissuedbooks('allcirculated');
   if(result.status=='Success')
{
   if (result.recid == "0" || result.recid == "" || result.recid == null)
      {}
      else
      {
  
    var url=this.liservice.callurl+"pdf2/fineslip_75.php?clcd="+clcd+"&aycd="+aycd+"&id=0&recno="+result.recid;

    //window.open(url,'','_blank');
    window.open(url);
    
  }
  let localmodref=this.retalmodalRef;
localmodref.close();

let model2=this.modalRef;
model2.close();
this.getallissuedbooks('allcirculated');
//this.getlibtbkres();
//this.Refreshsummary();

}


else{


}
     
    }, error => 
   { alert('error in connection');
    this.showload='no';}
    
    );
  }
  }



  renewnbulk()
  {
   
 
   // this.isdisabled=true;
   this.showload='yes';
    this.renarrselbooks= this.arrallrenbooks.filter(function(arr)
    {

      return arr.selected==true;
    })
    var selbooks= this.renarrselbooks;

    if (selbooks.length!=undefined)
    {
//     for(let i=0;i<selbooks.length;i++)
//     {
// this.rebulkcalcduedate(selbooks[i].nod,i,selbooks[i]);
// //this.renarrselbooks[i].renduedt=this.dtdue;

//     }
//  var selrenbooks=this.retremaparr;
//     console.log('selrenbooks', selrenbooks);
    let clcd=localStorage.getItem('clcd');
    let aycd=localStorage.getItem('aycd');
    var selretbooks= selbooks.map( o => { return { id: o.id, bookid: o.bookid,stuid: o.stuid,memtype: o.memtype,renduedt:o.renduedt,duedt:o.duedt,nod:o.nod,fineamt:o.fineamt,remarks:this.retremarks,mop:this.mop} });
    
    console.log('selbook-SAVE',selretbooks);
    
    var asgnmtdata = { recdt: this.recdt,  clcd:clcd,aycd:aycd,issuedtls:selretbooks
    
  };

    console.log('asgnmtdata-SAVE', asgnmtdata);
    this.liservice.bulkrenewbook(asgnmtdata)
    .subscribe(result => {
        console.log('ret',JSON.stringify(result));
        alert (result.message);
        this.showload='no';
        this.retremarks="";
        this.mop='1';
        //this.isdisabled=false;
        //this.getallissuedbooks('allcirculated');
   if(result.status=='Success')
{
  if (result.recid == "0" || result.recid == "" || result.recid == null)
      {}
      else
      {
  
  
    var url=this.liservice.callurl+"pdf2/fineslip_75.php?clcd="+clcd+"&aycd="+aycd+"&id=0&recno="+result.recid;

    //window.open(url,'','_blank');
    window.open(url);
    
  }
  let localmodref=this.retalmodalRef;
localmodref.close();

let model2=this.modalRef;
model2.close();
this.getallissuedbooks('allcirculated');
//this.getlibtbkres();
//this.Refreshsummary();

}



     
    }, error => 
    {alert('error in connection');

    this.showload='no';}
    
    );
  }
  else
  {

    alert('Please select from list ');
    this.showload='no';
  }
  
  }


  rebulkcalcduedate(nod,i,obj)
  {
    debugger
    let today=new Date();
   // let tsdt=new Date()
    today.setDate(today.getDate()+ parseInt(nod));
   // this.dtdue=today;
   var retdt=this.renbulkcheckholiday(today.toISOString().split('T')[0],i,obj);
   //var retdt=renbulkcheckholiday(today.toISOString().split('T')[0],i,obj);
   
  // this.calendar.value = this.dtdue;
  //   this.calendar.updateInputfield();
    
    //this.calendar;
    //this.calendar.datepickerClick = true;
    //this.calendar.showOverlay(this.calendar.inputfieldViewChild.nativeElement);
    console.log('retdt',retdt);
  }

  renbulkcheckholiday(duedt,i,obj):string
  {
    debugger;
    var retduedt='';
    this.liservice.checkholiday(duedt)
    .subscribe(
           resultArray =>{
   // this.liservice.Getdashboarddata('dashcounts')
      console.log('result-dashcounts',resultArray) ;
     if(resultArray.hodt=="")
     {
      console.log('logcnt','1');
      // this.dtdue=duedt;
       this.renarrselbooks[i].duedt=duedt;
       obj.renduedt=duedt;
       this.retremaparr.push(obj);
       retduedt=duedt;
     }
     else
     {
      console.log('logcnt','2');
     // this.dueday=parseInt(this.dueday)+1;
       let ndt=new Date(resultArray.hodt);
       ndt.setDate(ndt.getDate()+ 1);
       this.renbulkcheckholiday(ndt.toISOString().split('T')[0],i,obj);

     }
      


      },
     error => console.log('Error :: ' + error)
  );
  return retduedt;
  }

  popcirculation()
  {
      this.liservice.Getdashboarddata('popularcirc')
    .subscribe(
           resultArray =>{
   // this.liservice.Getdashboarddata('dashcounts')
      console.log('result-dashcounts',resultArray) ;
      this.arrpopcirculation=resultArray;


      },
     error => console.log('Error :: ' + error)
  );
  }
 
  calcduedate(nod)
  {
    debugger
    let today=new Date();
   // let tsdt=new Date()
    today.setDate(today.getDate()+ parseInt(nod));
   // this.dtdue=today;
   this.checkholiday(today.toISOString().split('T')[0]);
   
  // this.calendar.value = this.dtdue;
  //   this.calendar.updateInputfield();
    
    //this.calendar;
    //this.calendar.datepickerClick = true;
    //this.calendar.showOverlay(this.calendar.inputfieldViewChild.nativeElement);
  }

  checkholiday(duedt)
  {
    debugger;
    this.liservice.checkholiday(duedt)
    .subscribe(
           resultArray =>{
   // this.liservice.Getdashboarddata('dashcounts')
      console.log('result-dashcounts',resultArray) ;
     if(resultArray.hodt=="")
     {
      console.log('logcnt','1');
       this.dtdue=duedt;
     }
     else
     {
      console.log('logcnt','2');
      this.dueday=parseInt(this.dueday)+1;
       let ndt=new Date(resultArray.hodt);
       ndt.setDate(ndt.getDate()+ 1);
       this.checkholiday(ndt.toISOString().split('T')[0]);

     }
      


      },
     error => console.log('Error :: ' + error)
  );
  }



  
 
  calcduedateren(nod)
  {
    debugger
    this.showload="yes";
    let today=new Date();
   // let tsdt=new Date()
    today.setDate(today.getDate()+ parseInt(nod));
   // this.dtdue=today;
   this.checkholidayren(today.toISOString().split('T')[0]);
   
  
  }

  checkholidayren(duedt)
  {
    debugger;
    this.showload="yes";
    let clcd=localStorage.getItem('clcd');
    let aycd=localStorage.getItem('aycd');
    this.liservice.checkholiday(duedt)
    .subscribe(
           resultArray =>{
   // this.liservice.Getdashboarddata('dashcounts')
      console.log('result-dashcounts',resultArray) ;
     if(resultArray.hodt=="")
     {
      console.log('logcnt','1');
       this.dtdue=duedt;


       var asgnmtdata = {clid: 0,  secid: 0,stuid:this.booksmodel.stuid, retdt: this.booksmodel.recdt, oprtype: 'renew', clcd:clcd,aycd:aycd,id:this.booksmodel.id,bookid:this.booksmodel.bookid,
        reason:this.booksmodel.reason,amount:this.booksmodel.amount,remarks:this.booksmodel.remarks,issuedt:'',duedt:this.dtdue,damagedfee:this.booksmodel.damagedfee,bkretstatus:'returned',memtype:this.booksmodel.memtype,
        wavedlamt:this.booksmodel.wavedlamt,waveddamt:this.booksmodel.waveddamt
      };
      console.log('asgnmtdata-SAVE', asgnmtdata);
      this.liservice.issuebook(asgnmtdata)
          .subscribe(resultArray => {
              console.log('ret-issuebook', resultArray);
              // this.dataSource = new MatTableDataSource(resultArray);
    this.isdisabled=false;
              alert(resultArray.message);
            
             if(resultArray.status=='Success')
    {
      if (resultArray.recid == "0" || resultArray.recid == "" || resultArray.recid == null)
      {}
      else
      {
        var url=this.liservice.callurl+"pdf2/fineslip_75.php?clcd="+clcd+"&aycd="+aycd+"&id=0&recno="+resultArray.recid;
    
        //window.open(url,'','_blank');
        window.open(url);
        
      }
      let localmodref=this.modalRef;
    localmodref.close();
    //this.Refreshsummary();
    this.getallissuedbooks('allcirculated');
    this.showload="no";
    }
    
    
    
    
          }, error =>
              {alert('error in connection');
              this.showload="no";
            
            }
          );
     }
     else
     {
      this.showload="yes";
      console.log('logcnt','2');
      this.dueday=parseInt(this.dueday)+1;
       let ndt=new Date(resultArray.hodt);
       ndt.setDate(ndt.getDate()+ 1);
       this.checkholidayren(ndt.toISOString().split('T')[0]);

     }
      


      },
     error => console.log('Error :: ' + error)
  );
  }

  ciractivemembers()
  {
      this.liservice.Getdashboarddata('repdefault')
    .subscribe(
           resultArray =>{
   // this.liservice.Getdashboarddata('dashcounts')
      console.log('result-arractmember',resultArray) ;
      this.arractmember=resultArray;


      },
     error => console.log('Error :: ' + error)
  );
  }
  cirdepartment()
  {
      this.liservice.Getdashboarddata('cirdept')
    .subscribe(
           resultArray =>{
   // this.liservice.Getdashboarddata('dashcounts')
      console.log('result-cirdept',resultArray) ;
      this.arrcirdept=resultArray;


      },
     error => console.log('Error :: ' + error)
  );
  }
  cirmonth()
  {
      this.liservice.Getdashboarddata('cirdate')
    .subscribe(
           resultArray =>{
   // this.liservice.Getdashboarddata('dashcounts')
      console.log('result-cirdate',resultArray) ;
      this.arrcirdate=resultArray;


      },
     error => console.log('Error :: ' + error)
  );
  }

  cirdate()
  {
      this.liservice.Getdashboarddata('cirmonth')
    .subscribe(
           resultArray =>{
   // this.liservice.Getdashboarddata('dashcounts')
      console.log('result-cirmonth',resultArray) ;
      this.arrcirmonth=resultArray;


      },
     error => console.log('Error :: ' + error)
  );
  }
  clickoverview()
  {
    this.catwiseisue();
    this. cirdate();
    this.cirmonth();
    this.cirdepartment();
    this.ciractivemembers();
    this.popcirculation();

    //this.Booksissue_received('dailybooks');
  }

  Booksissue_received(oprtype)
{
  
  this.liservice.Getdashboarddata(oprtype)
  .subscribe(
    
   resultArray =>{
    console.log('Booksissue_received-'+oprtype,resultArray) ;
    //this.clsdate=resultArray;
    var arr = [];
    var issued = [];
    var returned = [];
    for ( var i = 0; i < resultArray.length ; i++) {
      //console.log('multiarray -i',JSON.stringify(i));
       
            
            arr.push(resultArray[i].date15);
            issued.push(parseInt( resultArray[i].issued)); // 
            returned.push(parseInt( resultArray[i].returned));
            
           
    }
   
   this.barChartData = [
      { data: issued, label: 'Issued', 
     },
      { data: returned, label: 'Returned',
       },
    ];
     this.barChartLabels = arr;
  
   
    
    
   // this.dataSource = new MatTableDataSource(resultArray);
    },
   error => console.log("Error :: " + error)
)
}

  onselduedt()
  {
    this.dueday=this.calcnod();
  }
  Addbook()
  {
    debugger
    //alert(this.selbooktitle+'-'+this.selbookid);
    var clid = 0;
    var subid = 0;
    var secid = 0;
    var retdt = '';
    var oprtype = '';
    if (this.oprtype=='insert')
    {

      oprtype = 'issuebook';
    }
    else
    {
      oprtype = 'update';
    }
   
    let clcd=localStorage.getItem('clcd');
    let aycd=localStorage.getItem('aycd');
    console.log('selbook-SAVE', this.selmember);
    console.log('selbook-SAVE', this.selbook);
    //.toISOString().slice(0, 19).replace('T', ' ')
    var asgnmtdata = {clid: clid,  secid: secid,stuid:this.selmember.id, retdt: retdt, oprtype: oprtype, clcd:clcd,aycd:aycd,id:this.selmember.isid,bookid:this.selbook.bkid,
    remarks:this.isremarks,issuedt:this.dtissue,duedt:this.dtdue,
    memtype:this.selmember.usrtag,damagedfee:0,bkretstatus:this.bkretstatus
  };
    console.log('asgnmtdata-SAVE', asgnmtdata);
    this.cservice.issuebook(asgnmtdata)
    .subscribe(result => {
        console.log('ret',JSON.stringify(result));
        alert (result.message);
        this.getallissuedbooks('allcirculated');
   if(result.status=='Success')
{
  let localmodref=this.modalRef;
localmodref.close();
this.selmember={};
this.selbook={};
this.isremarks='';
this.showisuemodal=false;
//this.Refreshsummary();

}


else{


}
     
    }, error => 
    alert('error in connection')
    
    );
  }

  issuebulk()
  {
    //alert(this.selbooktitle+'-'+this.selbookid);
    this.showload="yes";
    var clid = 0;
    var subid = 0;
    var secid = 0;
    var retdt = '';
  
   
    let clcd=localStorage.getItem('clcd');
    let aycd=localStorage.getItem('aycd');
    console.log('selbook-SAVE', this.selmember);
    console.log('selbook-SAVE', this.selbook);
    
    var asgnmtdata = {clid: clid,  secid: secid,stuid:this.selmember.id, retdt: retdt,  clcd:clcd,aycd:aycd,id:this.selmember.isid,memtype:this.selmember.usrtag,issuedtls:this.arrselbooks,remarks:this.isremarks
    
  };
    console.log('asgnmtdata-SAVE', asgnmtdata);
    this.cservice.bulkbookcirculate(asgnmtdata)
    .subscribe(result => {
        console.log('ret',JSON.stringify(result));
        alert (result.message);
        this.showload="no";
        this.getallissuedbooks('allcirculated');
   if(result.status=='Success')
{
  let localmodref=this.modalRef;
localmodref.close();
this.selmember={};
this.selbook={};
this.bkaccno='';
this.isremarks='';
this.arrselbooks=[];
this.showisuemodal=false;
//this.Refreshsummary();

}


else{


}
     
    }, error => 
    {this.showload="no";
    alert('error in connection');}
    
    );
  }

  private calcnod() {
    debugger

    // The number of milliseconds in one day
    const ONE_DAY = 1000 * 60 * 60 * 24;

    // Calculate the difference in milliseconds
    //const differenceMs = Math.abs(this.dtissue - this.dtdue);
    const differenceMs = this.dtdue.getTime() - this.dtissue.getTime(); 

    // Convert back to days and return
    return Math.ceil(differenceMs / ONE_DAY);

}

  getissueddetails() {
    this.liservice.getissueddetails(this.selmember.stuid,'getstubooks')
        .subscribe(
        resultArray => {
            console.log('issueddata', resultArray);
            this.issuedetails = resultArray;
            
            
        },
        error => console.log("Error :: " + error)
        )
}
masmot() {
  this.mservice.masmotransaction()
      .subscribe(
      resultArray => {
          console.log('getmot', resultArray);
          this.Modeot = resultArray;
         
      },
      error => console.log("Error :: " + error)
      )
}
openrenretdialog(content,objdata,cmd) {
 //console.log('parseInt', parseInt('-2'));
 debugger;
 this.masmot();
 this.memid=objdata.stuid;
if (parseInt(objdata.duecount)>=0 && objdata.memtype.toLowerCase()=='student')
{
this.isrenewable=true;

}

else
{
  this.isrenewable=false;
}
  let today = new Date();
        this.date1 = today;
  this.booksmodel = objdata;
  //this.model.oprtag="update";
 
  //this.booksmodel.recdt=this.liservice.getdatetoday();
  this.booksmodel.recdt= this.liservice.getdatetoday();
  this.booksmodel.reason='1';
  this.booksmodel.oprtype='return';
  this.booksmodel.damagedfee=0;
  this.booksmodel.waveddamt=0;
  this.booksmodel.wavedlamt=0;
if(parseInt(objdata.fine)<=0 || objdata.colfine=="No")
{
  this.booksmodel.amount=0;
}

else if(parseInt(objdata.fine)>0 && objdata.colfine=="No")
{
  this.booksmodel.amount=0;
}
else
{
  this.booksmodel.amount=objdata.fine;
}
  console.log('booksmodel',this.booksmodel);
  this.modalOptions = {
    backdrop:'static',
    backdropClass:'customBackdrop',
    
   
  }
  this.modalRef=this.modalService.open(content,this.modalOptions);
  
  this.modalRef.result.then((result) => {
 
       
    }, (reason) => {
        
    });
}


getissuedhis(stuid,memtype) {
  this.liservice.getissuedbookdetails1(stuid,'issuedbktomem',memtype)
      .subscribe(
      resultArray => {
          console.log('issueddata', resultArray);
          this.arrissuehis = resultArray;
          this.getissuedbookinfocnts(stuid,memtype);
        //issuedbktomem  
          
      },
      error => console.log("Error :: " + error)
      )
}

openissuedhisdialog(content,bookid,obj) {
  debugger
  this.studentinfo=obj;
  this.getissuedhis(bookid,obj.memtype);
  this.modalOptions = {
    backdrop:'static',
    backdropClass:'customBackdrop',
    
   
  }
  this.modalRef=this.modalService.open(content,this.modalOptions);
  
  this.modalRef.result.then((result) => {
 
       
    }, (reason) => {
        
    });
}



openretalldialog(content,stuid,memtype) {
  //console.log('parseInt', parseInt('-2'));
 
   //console.log('booksmodel',this.booksmodel);
   this.getallreturnbooks(stuid,memtype);
   this.retalmodalOptions = {
     backdrop:'static',
     backdropClass:'customBackdrop',
     size:'lg'
     
    
   }
   this.retalmodalRef=this.modalService.open(content,this.modalOptions);
   
   this.retalmodalRef.result.then((result) => {
  
        
     }, (reason) => {
         
     });
 }

 
openrenewalldialog(content,stuid,memtype) {
  //console.log('parseInt', parseInt('-2'));
 
   //console.log('booksmodel',this.booksmodel);
   this.getallreturnbooks(stuid,memtype);
   this.retalmodalOptions = {
     backdrop:'static',
     backdropClass:'customBackdrop',
     size:'lg'
     
    
   }
   this.retalmodalRef=this.modalService.open(content,this.modalOptions);
   
   this.retalmodalRef.result.then((result) => {
  
        
     }, (reason) => {
         
     });
 }

deletefnc(id)
{
  var result = confirm("Are you sure you want to delete this?");
  if (result) {
  var clid = 0;
  var subid = 0;
  var secid = 0;
  var retdt = '';
  var oprtype = 'delete';
  let clcd=localStorage.getItem('clcd');
  let aycd=localStorage.getItem('aycd');
  
  var asgnmtdata = {clid: clid,  secid: secid,stuid:subid, retdt: retdt, oprtype: oprtype, clcd:clcd,aycd:aycd,id:id,bookid:0,
    reason:'',amount:0,remarks:'',issuedt:'',duedt:''
  };
  console.log('asgnmtdata-SAVE', asgnmtdata);
  this.liservice.issuebook(asgnmtdata)
      .subscribe(resultArray => {
          // console.log('ret-by', resultArray);
          // this.dataSource = new MatTableDataSource(resultArray);

          alert('Details Deleted');
         this.getallissuedbooks('allcirculated')
          

      }, error =>
          alert('error in connection')
      );
    }
}
SaveDetails(cmd) {
  debugger
  this.showload="yes";
  this.isdisabled=true;
  var clid  = 0;
  var subid = 0;
  var secid = 0;
  var retdt = this.booksmodel.recdt;
  var oprtype = cmd;
  var remarks = this.booksmodel.remarks;
  
  
 // var dbnm = this.tempdbnm;
  //var oprtag = this.model.oprtag;
  let clcd=localStorage.getItem('clcd');
  let aycd=localStorage.getItem('aycd');
  
  var asgnmtdata = {clid: clid,  secid: secid,stuid:this.booksmodel.stuid, retdt: retdt, oprtype: oprtype, clcd:clcd,aycd:aycd,id:this.booksmodel.id,bookid:this.booksmodel.bookid,
    reason:this.booksmodel.reason,amount:this.booksmodel.amount,remarks:remarks,issuedt:'',duedt:'',damagedfee:this.booksmodel.damagedfee,bkretstatus:'returned',memtype:this.booksmodel.memtype,
    wavedlamt:this.booksmodel.wavedlamt,waveddamt:this.booksmodel.waveddamt
  };
  console.log('asgnmtdata-SAVE', asgnmtdata);
  this.liservice.issuebook(asgnmtdata)
      .subscribe(resultArray => {
          console.log('ret-issuebook', resultArray);
          // this.dataSource = new MatTableDataSource(resultArray);
          this.showload="no";
this.isdisabled=false;
          alert(resultArray.message);
        
         if(resultArray.status=='Success')
{
  if (resultArray.recid == "0" || resultArray.recid == "" || resultArray.recid == null)
  {}

  else
  {
    var url=this.liservice.callurl+"pdf2/fineslip_75.php?clcd="+clcd+"&aycd="+aycd+"&id=0&recno="+resultArray.recid;

    //window.open(url,'','_blank');
    window.open(url);
    
  }
  let localmodref=this.modalRef;
localmodref.close();
//this.Refreshsummary();
this.getallissuedbooks('allcirculated')
}


else{

  this.showload="no";
}

      }, error =>
      {
        this.showload="no";
          alert('error in connection');}
      );
}


Renewbook(cmd) {
  debugger
  this.showload="yes";
  this.isdisabled=true;
  var clid  = 0;
  var subid = 0;
  var secid = 0;
  var retdt = this.booksmodel.recdt;
  var oprtype = cmd;
  var remarks = this.booksmodel.remarks;
  
  
 // var dbnm = this.tempdbnm;
  //var oprtag = this.model.oprtag;


  this.calcduedateren(this.booksmodel.nod);
  
//   var asgnmtdata = {clid: clid,  secid: secid,stuid:this.booksmodel.stuid, retdt: retdt, oprtype: oprtype, clcd:clcd,aycd:aycd,id:this.booksmodel.id,bookid:this.booksmodel.bookid,
//     reason:this.selfine,amount:this.booksmodel.amount,remarks:remarks,issuedt:'',duedt:this.dtdue,damagedfee:this.booksmodel.damagedfee,bkretstatus:'returned',memtype:this.booksmodel.memtype,
//     wavedlamt:this.booksmodel.wavedlamt,waveddamt:this.booksmodel.waveddamt
//   };
//   console.log('asgnmtdata-SAVE', asgnmtdata);
//   this.liservice.issuebook(asgnmtdata)
//       .subscribe(resultArray => {
//           console.log('ret-issuebook', resultArray);
//           // this.dataSource = new MatTableDataSource(resultArray);
// this.isdisabled=false;
//           alert(resultArray.message);
        
//          if(resultArray.status=='Success')
// {
//   let localmodref=this.modalRef;
// localmodref.close();
// //this.Refreshsummary();
// this.getallissuedbooks('allcirculated')
// }


// else{


// }

//       }, error =>
//           alert('error in connection')
//       );
}


checklimit() {
  debugger

  this.cservice.checkbooklimit(this.booksmodel.bookid,this.booksmodel.stuid,this.memtype)
      .subscribe(resultArray => {
          console.log('ret-issuebook', resultArray);
          // this.dataSource = new MatTableDataSource(resultArray);

          alert(resultArray);
        
        

      }, error =>
          alert('error in connection')
      );
}


getallissuedbooks(oprtype) {
  this.cservice.getissueddetails(0,oprtype)
      .subscribe(
      resultArray => {
          console.log('allcirculated', resultArray);
          this.issuedetails = resultArray;
          
          
      },
      error => console.log("Error :: " + error)
      )
}

extendduedate() {

  var result = confirm("Are you sure you want to extend due dates ?");
  if (result)
  {
  this.liservice.extendduedate()
      .subscribe( 
      resultArray => {
          alert(resultArray.message);
          
          
      },
      error => {alert('Error');
      }
      )
    }
}

getallreturnbooks(stuid,memtype) {
  this.liservice.getstuissuedbooks(stuid,'stucirculated',memtype)
      .subscribe(
      resultArray => {
          console.log('allcirculated', resultArray);
          this.arrallretbooks = resultArray;
          this.arrallretbooks.map(function(entry) {
            entry.selected = true;
            entry.wavedfamt=0;
            entry.wavedramt=0
            entry.recamt=0
            return entry;
        });
        this.arrallrenbooks=resultArray;

        this.arrallrenbooks.map(function(entry) {
          entry.selected = true;
          entry.renduedt = '';
          if(entry.duecount<0)
          {
            entry.duedays=entry.duecount;
            entry.fineamt=entry.fine;
          }
          else{
            entry.duedays=0;
            entry.fineamt=0;
          }
         
          return entry;
      });
       // this.selectAll();
       console.log('allcirculated1', this.arrallrenbooks);
          
      },
      error => console.log("Error :: " + error)
      )
}
selectedAll: any=true;
selectAll() {
    for (var i = 0; i < this.arrallretbooks.length; i++) {
      this.arrallretbooks[i].selected = this.selectedAll;
    }
  }
  checkIfAllSelected() {
    this.selectedAll = this.arrallretbooks.every(function(item:any) {
        return item.selected == true;
      })
  }


  renselectedAll: any=true;
renselectAll() {
    for (var i = 0; i < this.arrallretbooks.length; i++) {
      this.arrallrenbooks[i].selected = this.renselectedAll;
    }
  }
  rencheckIfAllSelected() {
    this.renselectedAll = this.arrallrenbooks.every(function(item:any) {
        return item.selected == true;
      })
  }

  
getissuealsbetdates(oprtype,bkretstatus) {
  debugger

  console.log('this.fserdt',this.fserdt);
  this.liservice.getlibissuehistory(oprtype,bkretstatus,this.fserdt,this.fserdt4)
      .subscribe(
      resultArray => {
          console.log('allcirculated', resultArray);
          this.arrhis = resultArray;
          
          
      },
      error => console.log("Error :: " + error)
      )
}


exportbookmas(){
  var clcd=localStorage.getItem('clcd');
  var aycd=localStorage.getItem('aycd');
   var url=this.liservice.callurl+"export/expduerecovery.php?clcd="+clcd+"&aycd="+aycd+"&frdt="+this.fserdt+"&todt="+this.fserdt4+"&tag=bookdetailswithfine1";

   //window.open(url,'','_blank');
   window.open(url);
 }

 printfinerec(id,recno,flnm){
  var clcd=localStorage.getItem('clcd');
  var aycd=localStorage.getItem('aycd');
   var url=this.liservice.callurl+"pdf2/"+flnm+".php?clcd="+clcd+"&aycd="+aycd+"&id="+id+"&recno="+recno;

   //window.open(url,'','_blank');
   window.open(url);
 }

getissuealsbetdatesfine(oprtype,bkretstatus) {
  debugger

  console.log('this.fserdt',this.fserdt);
  this.liservice.getlibissuehistory(oprtype,bkretstatus,this.fserdt,this.fserdt4)
      .subscribe(
      resultArray => {
          console.log('allcirculated', resultArray);
          this.arrhisfine = resultArray;
          
          
      },
      error => console.log("Error :: " + error)
      )
}
  onmemberselectEvent(item) {
//alert('hi');
    console.log('item',item);
    //this.selmember=item;
    this.getissuedbookinfocnts(item.id,this.memtype);
  //  this.getissueddetails();
    // do something with selected item
  }
 
  onmemberChangeSearch(sertxt) {
    debugger
    // fetch remote data from here
    // And reassign the 'data' which is binded to 'data' property.
    if(sertxt.query.length>=3) 
    {
    this.getmemberdetails(this.memtype,sertxt.query);
    }
  }
  OnHumanSelected(selitem) {
    console.log('### Trigger');
    console.log(selitem);
    // console.log(this.selitem);
    // this.selbookid=selitem.bookid;
    // this.selbooktitle=selitem.booktitle;
    
  }
  checkissuelimit()
  {
    this.liservice.checklimit(this.selbook.bkid,this.selmember.id)
    .subscribe(resultArray => {
        console.log('ret-issuebook', resultArray);
        // this.dataSource = new MatTableDataSource(resultArray);

       // alert(resultArray.chkres.msgissue);
        if (resultArray.chkres.msgissue=='Yes')
        {
         
        }
        else{

          alert("Issue limit exceded for this member");
        }
      
      

    }, error =>
        alert('error in connection')
    );
  

  }
  addselbook()
  {
    debugger
    // var asgnmtdata = {clid: clid,  secid: secid,stuid:this.selmember.id, retdt: retdt, oprtype: oprtype, clcd:clcd,aycd:aycd,id:this.selmember.isid,bookid:this.selbook.bkid,
    //   remarks:this.isremarks,issuedt:this.dtissue.toISOString().slice(0, 19).replace('T', ' '),duedt:this.dtdue.toISOString().slice(0, 19).replace('T', ' '),
    //   memtype:this.selmember.usrtag
    // };
    let item1 = this.arrselbooks.find(i => i.accno == this.selbook.accno);
console.log('filteredvalue',item1);
if(item1 !=undefined)
{
  this.showload="no";
  alert('Book already selected ');
  return;
}
    this.cservice.checkbooklimit(this.selbook.bkid,this.selmember.id,this.memtype)
      .subscribe(resultArray => {
          console.log('ret-issuebook', resultArray);
          // this.dataSource = new MatTableDataSource(resultArray);

         // alert(resultArray.chkres.msgissue);
          if (resultArray.chkres.msgissue=='Yes')
          {
            let cntisuable=parseInt(resultArray.chkres.islimit);
            let cntissued=this.arrselbooks.length+1+parseInt(resultArray.chkres.issuedcnt);
            if(cntissued<=cntisuable)
            {
            var objselbk:any={};
     objselbk.bookid=this.selbook.bkid;
     objselbk.accno=this.selbook.accno;
     objselbk.author=this.selbook.author;
     objselbk.title=this.selbook.title;
     objselbk.remarks=this.isremarks;
     objselbk.issuedt=this.dtissue.toISOString().slice(0, 19).replace('T', ' ');
     //objselbk.duedt=this.dtdue.toISOString().slice(0, 19).replace('T', ' ');
     objselbk.duedt=this.dtdue;
     objselbk.copiesleft=this.objcopies.copiesleft;
     objselbk.dueday=this.dueday;
     this.arrselbooks.push(objselbk);
     console.log('after add',this.arrselbooks);
     this.selbook={};
     this.objcopies={};
     this.bkaccno='';
            }
            else
            {
              alert("Issue limit will exceed ");
              this.showload="no";

            }
          }
          else{

            alert("Issue limit exceded for this member");
            this.showload="no";
          }
        
          this.showload="no";

      }, error =>
      {
          alert('error in connection');
          this.showload="no";
      }
      );
    

  }

  removebook(ind)
  {
//alert(ind);
this.arrselbooks.splice(ind,1);
  }
  onbookselectEvent(item) {
    debugger
    console.log('item',item);
    this.copiesleft(item.bkid);
    if(item.bkstatus=='Available')
    {
    this.selbook=item;

    if (this.selmember.usrtag=='staff')
    {
      this.dueday='365';
    }
    else
    {
    this.dueday=this.selbook.nod;
    }
    this.calcduedate(this.dueday);
    }
    else
    {
      this.selbook={};
    }
    // do something with selected item
  }

  onbookscan(item) {
    debugger
    this.showload="yes";
    console.log('item',item);
   
    if(item.bkstatus=='Available')
    {
    this.selbook=item;

    if (this.selmember.usrtag=='staff')
    {
      this.dueday='365';
    }
    else
    {
    this.dueday=this.selbook.nod;
    }
    this.calcduedate(this.dueday);

    this.copiesleft(item.bkid);
    
   
    }
    else
    {
      this.selbook={};
      alert('Search Results \nNot Available - Issued');
      this.bkaccno='';
      this.showload="no";
    }
   
    // do something with selected item
  }
 
  onbookChangeSearch(sertxt) {
    // fetch remote data from here
    // And reassign the 'data' which is binded to 'data' property.
    if(sertxt.query.length>=3)
    {
    this.applybooksFilter(sertxt.query);
    }
  }
  
  onFocused(e){
    // do something when input is focused
  }
  onFocused1(e){
    // do something when input is focused
  }
  getmemberdetails(oprtype,sertxt) {
    this.cservice.getlibmemberdetails(oprtype,sertxt,0,0)
        .subscribe(
        resultArray => {
            console.log('members-result', resultArray);
            this.memberdetails = resultArray;
            
        },
        error => console.log("Error :: " + error)
        )
  }
  openinfo(content)
  {
  
    this.modalRef=this.modalService.open(content,this.modalOptions);
    
    this.modalRef.result.then((result) => {
   
         
      }, (reason) => {
          
      });
  }

  applybooksFilter(filterValue: string) {
    // filterValue = filterValue.trim(); // Remove whitespace
    // filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
  
    
      debugger
      //this.isLoadingResult = true;
    this.liservice.serchbooks(filterValue,'cirbook',0)
    .subscribe(
    resultArray => {
        console.log('books-result', resultArray);
        this.bookdetails = resultArray;
      
        
    },
    error => console.log("Error :: " + error)
    )
    //this.isLoadingResult = false;
  }

  scanedbook(filterValue) {
    // filterValue = filterValue.trim(); // Remove whitespace
    // filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
  
    this.isLoadingResult = !this.isLoadingResult;
    this.showload="yes";
      debugger

      let item1 = this.arrselbooks.find(i => i.accno == this.selbook.accno);
      console.log('filteredvalue',item1);
      if(item1 !=undefined)
      {
      
        alert('Search Results. \nBook already selected');
        this.showload="no";
        this.bkaccno='';
        return;
      }
     
    this.liservice.serchbooks(filterValue,'cirbook',0)
    .subscribe(
    resultArray => {
        console.log('books-result', resultArray);
        if(resultArray==undefined)
        {
          alert('Search Results. \nNot Available - Not in library collection');
          this.showload="no"; 
          this.bkaccno='';
        }
        else{
        if(resultArray.length>0)
        {
          if (resultArray[0].acsnm=='Accession')
          {
       this.onbookscan(resultArray[0]);
          }

          else
          {

            alert('Search Results. \nNot Available - '+resultArray[0].acsnm);
          this.showload="no"; 
          this.bkaccno='';
          }
        }
        else
        {
          alert('Search Results. \nNot Available - Not in library collection');
          this.showload="no"; 
          this.bkaccno='';
        }
      }
      
        
    },
    error => {console.log("Error :: " + error);
    alert('Unexpected error');
    this.showload="no"; 
    this.bkaccno='';
  }
    )
   
  }

  copiesleft(filterValue: string) {
   
     
   this.liservice.serchbooks(filterValue,'copiesleft',0)
    .subscribe(
    resultArray => {
        console.log('copiesleft-result', resultArray);
        if(resultArray.length>0)
        {

          this.objcopies=resultArray[0];
          this.addselbook();
        }
        else
        {
          this.objcopies={};
          this.addselbook();
        }
        //this.bookdetails = resultArray;
      
        
    },
    error => console.log("Error :: " + error)
    )
   
  }

  searchCleared() {
    console.log('searchCleared');
    this.bookdetails = [];
  }
  opencategory(content,obj,oprtype) {
    this.isLoadingResult=false;
    console.log('length',this.arrselbooks.length);
    this.showisuemodal=true;
    console.log('obj',obj);
    this.oprtype=oprtype;
    this.objissued=obj;
    if (oprtype=='insert')
    {
    this.dtissue = new Date();
    //this.dtdue = today.getMonth() + '/' + today.getDate() + '/' + today.getFullYear();
    this.dtdue = new Date();
    this.dueday='0';
    this.selmember.isid='0';
  }
  else
  {
    this.selmember.isid=obj.id;
    this.selmember.id=obj.stuid;
    this.selmember.usrtag=obj.memtype;
    this.dtissue=new Date(obj.issuedt);
    this.dtdue=new Date(obj.duedt);
    this.dueday=obj.duecount;
    this.isremarks=obj.remarks;

  }
    this.modalOptions = {
      backdrop:'static',
      backdropClass:'customBackdrop',
      size:'med'
     
    }
    this.modalRef=this.modalService.open(content,this.modalOptions);
    
    this.modalRef.result.then((result) => {
   
         
      }, (reason) => {
          
      });
  }
  
  getissuedbookinfocnts(stuid,memtype) {
    this.liservice.getissuedbookinfocnts1(stuid,memtype)
        .subscribe(
        resultArray => {
            console.log('issueddata', resultArray);
            this.issuedinfocnt = resultArray[0];
          //issuedbktomem  
            
        },
        error => console.log("Error :: " + error)
        )
  }

  openeditmodal(content,obj,oprtype) {
    console.log('length',this.arrselbooks.length);
    this.showisuemodal=true;
    console.log('obj',obj);
    this.oprtype=oprtype;
    this.objissued=obj;
    if (oprtype=='insert')
    {
    this.dtissue = this.liservice.getdatetoday();
    //this.dtdue = today.getMonth() + '/' + today.getDate() + '/' + today.getFullYear();
    this.dtdue = this.liservice.getdatetoday();
    this.dueday='0';
    this.selmember.isid='0';
    
  }
  else
  {
    this.selmember.isid=obj.id;
    this.selmember.id=obj.stuid;
    this.selmember.usrtag=obj.memtype;
    this.dtissue=obj.issuedt;
    this.dtdue=obj.duedt;
    this.dueday=obj.duecount;
    this.isremarks=obj.remarks;
    this.bkretstatus=obj.bkretstatus;
    

  }
    this.modalOptions = {
      backdrop:'static',
      backdropClass:'customBackdrop',
      size:'med'
     
    }
    this.modalRef=this.modalService.open(content,this.modalOptions);
    
    this.modalRef.result.then((result) => {
   
         
      }, (reason) => {
          
      });
  }
  onChangetype(val)
  {

this.selres=val;
  }
  onChangefine(val)
  {
    this.selfine=val;
    //this.booksmodel.amount=0;
  }

  onChangestatus(val)
  {
    this.selstatus=val;
    //this.booksmodel.amount=0;
  }


  circlick()
  {

    this.Dasheadcounts();
    this.getallissuedbooks('allcirculated');
  }

  histclick()
  {
    this.selstat='returned';
    this.showfine=false;
    this.getissuealsbetdates('book_date_status1',this.selstat);
  }

  exporthistory(oprtype){
   // this.isLoadingResult=true;
    var clcd=localStorage.getItem('clcd');
    var aycd=localStorage.getItem('aycd');

     var url=this.liservice.callurl+"export/expcirhistory.php?clcd="+clcd+"&aycd="+aycd+"&oprtype="+oprtype+"&dtfrm="+this.fserdt+"&dtto="+this.fserdt4+"&sertxt="+this.sertxt+"&bkretstatus="+this.selstat;
  
     //window.open(url,'','_blank');
     window.open(url);
   }

   exportoverview(oprtype){
    // this.isLoadingResult=true;
     var clcd=localStorage.getItem('clcd');
     var aycd=localStorage.getItem('aycd');
 
       var url=this.liservice.callurl+"export/expciroverview.php?clcd="+clcd+"&aycd="+aycd+"&oprtype="+oprtype;
      // const url= window.URL.createObjectURL(blob);
      window.open(url);
     // window.open(url,'','_blank');
    }
  fineclick()
  {
    this.selstat='returned';
    this.showfine=true;
    this.getissuealsbetdatesfine('bookdetailswithfine1',this.selstat);
  }

  openreturneditmodal(content,obj,oprtype) {
    
    console.log('obj',obj);
    this.oprtype=oprtype;
    this.objretdata=obj;
    
    // this.selmember.isid=obj.id;
    // this.selmember.id=obj.stuid;
    // this.selmember.usrtag=obj.memtype;
     this.dtrec=obj.retdt;
    // this.dtdue=new Date(obj.duedt);
    // this.dueday=obj.duecount;
    // this.isremarks=obj.remarks;
    this.selstatus=obj.bkretstatus;
    

  
    this.modalOptions = {
      backdrop:'static',
      backdropClass:'customBackdrop',
     
     
    }
    this.modalRef=this.modalService.open(content,this.modalOptions);
    
    this.modalRef.result.then((result) => {
   
         
      }, (reason) => {
          
      });
  }


  catwiseisue()
  {
      this.liservice.Getdashboarddata('catwiseissue')
    .subscribe(
           resultArray =>{
   // this.liservice.Getdashboarddata('dashcounts')
      console.log('result-catwiseissued',resultArray) ;
      this.catwiseissued=resultArray;


      },
     error => console.log('Error :: ' + error)
  );
  }

  Edithistorydetails()
  {
    debugger
    var clid = 0;
    var subid = 0;
    var secid = 0;
    var retdt = this.objretdata.recdt;
    var oprtype = 'editreturn';
    var remarks = this.objretdata.remarks;
    
   // var dbnm = this.tempdbnm;
    //var oprtag = this.model.oprtag;
    let clcd=localStorage.getItem('clcd');
    let aycd=localStorage.getItem('aycd');
    
    var asgnmtdata = {clid: clid,  secid: secid,stuid:this.objretdata.stuid, retdt: this.dtrec, oprtype: oprtype, clcd:clcd,aycd:aycd,id:this.objretdata.id,bookid:this.objretdata.bookid,
      reason:this.selfine,amount:this.objretdata.fineamt,remarks:remarks,issuedt:'',duedt:'',damagedfee:this.objretdata.fineamt1,bkretstatus:this.selstatus,memtype:this.objretdata.memtype,wavedlamt:this.objretdata.wavedlamt,waveddamt:this.objretdata.waveddamt
    };
    console.log('asgnmtdata-SAVE', asgnmtdata);
    this.liservice.issuebook(asgnmtdata)
        .subscribe(resultArray => {
            console.log('ret-issuebook', resultArray);
            // this.dataSource = new MatTableDataSource(resultArray);
  
            alert(resultArray.message);
          
           if(resultArray.status=='Success')
  {
    let localmodref=this.modalRef;
  localmodref.close();
  //this.Refreshsummary();
  if(this.showfine==true)
  {
    this.fineclick();
  }

  else
  {
    this.histclick();
  }
  }
  
  
  else{
  
  
  }
  
        }, error =>
            alert('error in connection')
        );
  }
  clickinfo1()
  {
    this.infotag='allcirculated1';
    this.getallissuedbooks('allcirculated');
}
  clickinfo2()
  {
    this.infotag='dueforday';
    this.getallissuedbooks('dueforday');}
  clickinfo3()
  {
    this.infotag='duelapsed';
    this.getallissuedbooks('duelapsed');}
}

